<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b>组织动态 共{{ total }}条</b>
            <div class="flex align-center">
                <router-link class="page-back  margin-right-xs" to="/organization/organ/dynamic/apply">审核列表
                </router-link>
                <router-link class="add-btn" to="/organization/organ/dynamicEdit/0"
                >发布动态
                </router-link
                >
            </div>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm list-search">
            <el-input
                v-model="keyWord"
                placeholder="请输入发布动态标题关键字"
            ></el-input>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        </div>
        <el-skeleton v-if="loading" :rows="10"/>
        <empty v-if="noData" :type="1"/>
        <div class="list-box">
            <div v-for="item in list" :key="item.id" class="item-notice flex align-center margin-bottom-sm">
                <el-image :src="item.thumb" class="image flex-shrink" fit="cover"></el-image>
                <div class="flex flex-direction justify-between flex-sub margin-left-sm overflow-hidden">
                    <div class="title ovHide">{{ item.title }}</div>
                    <div class="content ovHide2">
                        {{ item.content }}
                    </div>
                    <div class="time">{{ item.create_time }}</div>
                </div>
                <div class="flex-shrink flex flex-direction align-center justify-center margin-left">
                    <router-link
                        :to="'/organization/organ/dynamicEdit/' + item.id"
                        class="margin-lr-xs"
                    >
                        <el-button class="operate" round type="primary"
                        >编辑
                        </el-button
                        >
                    </router-link>

                    <el-button class="operate line margin-top-sm" round @click="deleteItem(item.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div v-if="list.length > 0" class="flex align-center justify-between">
            <span>共{{ total }}条数据</span>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {delActive, getActiveList} from "@/api/organiz";
import {reg_html} from '@/utils/rules'

export default {
    name: "dynamic",
    data() {
        return {
            page: 1,
            limit: 10,
            total: 0,
            keyWord: '',
            list: [],
            noData: false,
            loading: true,
            cur_aid: 0,
            detailDialogVisible: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [5, 1], '组织动态')
        this.getList()
    },
    components: {},
    methods: {
        async getList() {
            this.list = []
            this.loading = true
            let _list = await getActiveList(this.page, this.limit, this.keyWord)
            if (_list.status === 0) {
                this.list = [], this.noData = true, this.loading = false, this.total = 0
            } else {
                _list.data.data.map(item => {
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, "")
                })
                this.loading = false, this.noData = false, this.list = _list.data.data, this.total = _list.data.total
            }
        },
        search() {
            this.page = 1
            this.getList()
        },
        deleteItem(id) {
            this.$confirm("确定要删除此组织动态吗", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delActive(id)
            })
        },
        async delActive(id) {
            let _data = await delActive(id)
            if (_data.status === 200) {
                this.getList()
                this.$message.success(_data.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
        }
    }

    .list-search {
        .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .item-notice {
        width: 100%;
        min-height: 159px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        margin-top: 20px;
        padding: 11px 20px;

        .title {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
        }

        .content {
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            margin-top: 19px;
        }

        .image {
            width: 154px;
            height: 116px;
            border-radius: 10px;
        }

        .time {
            font-size: 14px;
            color: #999999;
            margin-top: 19px;
        }

        .operate {
            width: 99px;
            height: 40px;
            background-color: #0a2240;
            border-radius: 20px;
            font-size: 14px;
            color: #ffffff;
            border: none;

            &.line {
                width: 99px;
                height: 40px;
                border-radius: 20px;
                border: solid 1px #0a2240;
                background: transparent;
                font-size: 14px;
                color: #0a2240;
            }
        }
    }
}
</style>